import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src3507326296/src/luckywise/layouts/default.vue").then(m => m.default || m)),
  legal: defineAsyncComponent(() => import("/codebuild/output/src3507326296/src/luckywise/layouts/legal.vue").then(m => m.default || m)),
  minimal: defineAsyncComponent(() => import("/codebuild/output/src3507326296/src/luckywise/layouts/minimal.vue").then(m => m.default || m))
}